export const isReportTemplateWithSuiteNavData = report => report.get('suiteNavData') !== undefined;